import React, { useContext } from 'react';
import { ICredentialsContext, CredentialsContext } from '../../../credentialsState/credentialsContext';
import SearchField from 'components/SearchField/SearchField';

export const Search: React.FC = () => {
	const { changeSearchString, searchString, credentials } = useContext<ICredentialsContext>(CredentialsContext);

	return (
		<SearchField
			onChangeSelectSearchString={changeSearchString}
			searchString={searchString}
			delay={credentials.count ? 800 : undefined}
		/>
	);
};
